import { CertificateDocumentTypeV2, ECMContentType } from '../../enums/CertificateDocumentType'
import {
  CategoryType,
  ICategoryType,
  InspectionCategoryList,
  R2CCategoryList,
  TestReportCategoryList,
} from '../../enums/CetificateFileCategoryType'

export const attachmentTabs = [
  {
    id: CertificateDocumentTypeV2.Certificate,
    name: 'Certificate',
    index: 0,
  },
  {
    id: CertificateDocumentTypeV2.TestReport,
    name: 'Reports',
    index: 1,
  },
  {
    id: CertificateDocumentTypeV2.R2CPackage,
    name: 'R2C Package',
    index: 2,
  },
  {
    id: CertificateDocumentTypeV2.InspectionSurveillance,
    name: 'Inspection/Surveillance',
    index: 3,
  },
  {
    id: CertificateDocumentTypeV2.InternalFiles,
    name: 'Internal Files',
    index: 4,
  },
]

export const getAttachmentFileName = (
  fileName: string,
  type: CertificateDocumentTypeV2,
  category: CategoryType,
  contentType: ECMContentType
): string => {
  let prefix: string = ''
  switch (type) {
    case CertificateDocumentTypeV2.Certificate:
    case CertificateDocumentTypeV2.TestReport:
      prefix = getContentTypePrefix(contentType)
      break
    case CertificateDocumentTypeV2.R2CPackage:
    case CertificateDocumentTypeV2.InspectionSurveillance:
      prefix = getCategoryPrefix(category)
      break
  }
  fileName = `${prefix}${fileName}`
  return fileName
}

const getContentTypePrefix = (contentType: ECMContentType): string => {
  let prefix: string = ''
  switch (contentType) {
    case ECMContentType.Certificate:
    case ECMContentType.Doc:
    case ECMContentType.ConformityMarking:
      prefix = 'Deliverable_'
      break
    case ECMContentType.TestReport:
      prefix = 'TestReport_'
      break
    case ECMContentType.ClassificationReport:
      prefix = 'ClassificationReport_'
      break
    case ECMContentType.AssessmentReport:
      prefix = 'AssessmentReport_'
      break
    case ECMContentType.DescriptiveReport:
      prefix = 'DescriptiveReport_'
      break
    case ECMContentType.EvaluationReport:
      prefix = 'EvaluationReport_'
      break
    case ECMContentType.WithdrawalLetter:
      prefix = 'WithdrawalLetter_'
      break
    case ECMContentType.SuspensionLetter:
      prefix = 'SuspensionLetter_'
      break
    case ECMContentType.LetterReport:
      prefix = 'LetterReport_'
      break
    case ECMContentType.Eta:
      prefix = 'ETAReport_'
      break
    case ECMContentType.Ukta:
      prefix = 'UKTAReport_'
      break
  }

  return prefix
}

const getCategoryPrefix = (category: CategoryType): string => {
  let prefix: string = ''
  switch (category) {
    case CategoryType.ApplicationForm:
      prefix = 'ApplicationDoc_'
      break
    case CategoryType.Label:
      prefix = 'Label_'
      break
    case CategoryType.Manual:
      prefix = 'Manual_'
      break
    case CategoryType.OtherSupportingDocuments:
      prefix = 'SupportingDoc_'
      break
    case CategoryType.FactoryInspectionReport:
      prefix = 'FIReport_'
      break
    case CategoryType.MarketSurveillanceReport:
      prefix = 'MSReport_'
      break
    case CategoryType.MSComplianceLetter:
      prefix = 'MSComplianceLetter_'
      break
    case CategoryType.MSSamplingForm:
      prefix = 'MSSamplingForm_'
      break
    case CategoryType.MSEvaluationForm:
      prefix = 'MSEvaluationForm_'
      break
    case CategoryType.MSAdditionalSurveillance:
      prefix = 'MSSupportingDoc_'
      break
    case CategoryType.EvaluationReport:
      prefix = 'EvaluationReport_'
      break
    case CategoryType.TestReference:
      prefix = 'TestReference_'
      break
    case CategoryType.Classification:
      prefix = 'ClassificationReference_'
      break
    case CategoryType.Assessment:
      prefix = 'AssessmentReference_'
      break
    case CategoryType.Eta:
      prefix = 'ETAReference_'
      break
    case CategoryType.Ukta:
      prefix = 'UKTAReference_'
      break
    case CategoryType.Compliance:
      prefix = 'Compliance_'
      break
    case CategoryType.InitialFpcAssessmentReport:
      prefix = 'FPCInitial_'
      break
    case CategoryType.FpcAssessmentReport:
      prefix = 'FPCSurveillance_'
      break
    case CategoryType.AuditTesting:
      prefix = 'AuditTesting_'
      break
    case CategoryType.SupportingDoc:
      prefix = 'SupportingDoc_'
      break
  }
  return prefix
}

export const getContentType = (documentType: CertificateDocumentTypeV2): ECMContentType => {
  let contentType: ECMContentType = ECMContentType.None
  switch (documentType) {
    case CertificateDocumentTypeV2.Certificate:
      contentType = ECMContentType.Certificate
      break
    case CertificateDocumentTypeV2.TestReport:
      contentType = ECMContentType.TestReport
      break
    case CertificateDocumentTypeV2.R2CPackage:
      contentType = ECMContentType.R2CPackageDocument
      break
    case CertificateDocumentTypeV2.InspectionSurveillance:
      contentType = ECMContentType.None
      break
    case CertificateDocumentTypeV2.InternalFiles:
      contentType = ECMContentType.InternalFiles
      break
  }
  return contentType
}

export const getContentTypeDescription = (rowData: any) => {
  switch (rowData.ecmContentType) {
    case ECMContentType.Certificate:
      return 'Certificate'
    case ECMContentType.Doc:
      return 'DoC'
    case ECMContentType.ConformityMarking:
      return 'Conformity Marking'
    case ECMContentType.TestReport:
      return 'Test Report'
    case ECMContentType.ClassificationReport:
      return 'Classification Report'
    case ECMContentType.AssessmentReport:
      return 'Assessment Report'
    case ECMContentType.DescriptiveReport:
      return 'Descriptive Report'
    case ECMContentType.EvaluationReport:
      return 'Evaluation Report'
    case ECMContentType.R2CPackageDocument:
      return 'R2C Package Document'
    case ECMContentType.FactoryInspectionReports:
      return 'Factory Inspection Reports'
    case ECMContentType.MarketSurveillanceReports:
      return 'Market Surveillance Reports'
    case ECMContentType.InternalFiles:
      return 'Supporting Document'
    case ECMContentType.WithdrawalLetter:
      return 'Withdrawal Letter'
    case ECMContentType.SuspensionLetter:
      return 'Suspension Letter'
    case ECMContentType.LetterReport:
      return 'Letter Report'
    case ECMContentType.Eta:
      return 'ETA Report'
    case ECMContentType.Ukta:
      return 'UKTA Report'
    case ECMContentType.None:
    default:
      return ''
  }
}

export const getContentTypeByCategory = (categoryType: CategoryType) => {
  switch (categoryType) {
    case CategoryType.None:
      return ECMContentType.None
    case CategoryType.FactoryInspectionReport:
      return ECMContentType.FactoryInspectionReports
    case CategoryType.MarketSurveillanceReport:
    case CategoryType.MSComplianceLetter:
    case CategoryType.MSSamplingForm:
    case CategoryType.MSEvaluationForm:
    case CategoryType.MSAdditionalSurveillance:
    case CategoryType.FpcAssessmentReport:
    case CategoryType.AuditTesting:
    case CategoryType.SupportingDoc:
      return ECMContentType.MarketSurveillanceReports
  }
}

export const getCategoryDescription = (category: CategoryType, tab: CertificateDocumentTypeV2) => {
  let categoryList: ICategoryType[]
  if (tab === CertificateDocumentTypeV2.TestReport) categoryList = TestReportCategoryList
  else if (tab === CertificateDocumentTypeV2.R2CPackage) categoryList = R2CCategoryList
  else categoryList = InspectionCategoryList

  return categoryList.find((type: ICategoryType) => type.value == category)?.name
}
